var SETTING_GN={
  ww:function(){ var v=(window.innerWidth)?window.innerWidth:$(window).width(); return v; },
  wh:function(){ var v=(window.innerHeight)?window.innerHeight:$(window).height(); return v; },
  dh:function(){
    var v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st:function(){ var v=$(window).scrollTop(); return v; },
  hh:function(){ var v=$('.hd-top').innerHeight(); return v; },
  picsel:function(num){ var v=Math.floor((num*SETTING_GN.ww())/750); return v; },
  c_picsel:function(a,b,c){ var v=Math.floor((a*c)/b); return v; },
  ua:navigator.userAgent
};

// ユーザーエージェントまたはウィンドウサイズからPCかを判別
var is_sp=function(){ var v=(SETTING_GN.ww()<=768)?true:false; return v; };
var is_pc=function(){ var v=(SETTING_GN.ww()>=769)?true:false; return v; };
var is_touch=function(){ var v=(SETTING_GN.ua.indexOf('iPhone')>1||SETTING_GN.ua.indexOf('iPad')>1||SETTING_GN.ua.indexOf('Android')>1)?true:false; return v; };

var escapeHtml=function(string){
  if(typeof string!=='string') return string;
  return string.replace(/[&'`"<>]/g,function(match){
    return {
      '&':'&amp;',
      "'":'&#x27;',
      '`':'&#x60;',
      '"':'&quot;',
      '<':'&lt;',
      '>':'&gt;'
    }[match]
  });
};

var urlPrmArr=function(){
  var url=location.search.substring(1).split('&');
  var arr=[];
  for(var i=0;url[i];i++){
    var prm=url[i].split('=');
    var k=decodeURIComponent(prm[0]);
    var v=decodeURIComponent(prm[1]);
    v=escapeHtml(v);
    arr[k]=v;
  };
  return arr;
};

jQuery(function($){

  $.fn.extend({
    // ページ内スクロール
    pageScroll:function(options){
      var defaults={
        speed:600
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      $t.on('click',function(){
        var Hash=$(this.hash);
        if($(Hash).length){
          var minus=0;
          if(is_pc()&&SETTING_GN.st()<124){
            minus=16;
          };
          var HashOffset=$(Hash).offset().top-minus;
          $('html:not(:animated),body:not(:animated)').animate({ scrollTop:HashOffset+'px' },op.speed);
        };
        return false;
      });
    },
    // ウィンドウ幅可変によるサイズ調整
    winSizeSet:function(options){
      var defaults={
        set:new Function
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      $(window).on({ 'resize':function(){ op.set($t); } });
      $t.ready(function(){ op.set($t); });
    },
    // ログアウト後のリンク先
    logoutLocation:function(options){
      var defaults={
        trigger:'.click-logout',
        return:'/account/login'
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $trigger=$(op.trigger);
      $trigger.each(function(){
        $(this).off('click');
        $(this).on('click',function(){
          var href=$(this).attr('href');
          fetch(href).then(function(){
            window.location.href=op.return;
          });
          return false;
        });
      });
    },
    // 開閉ボックス
    toggleBox:function(options){
      var defaults={
        trigger:'',
        target:'',
        device:'',
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $trigger=$t.find(op.trigger);
      var $target=$t.find(op.target);
      var bool=true;
      switch(op.device){
      case 'sp' :
        bool=(is_sp())?true:false;
        break;
      case 'pc' :
        bool=(is_pc())?true:false;
        break;
      };
      if(bool){
        var toggleChange=function(){
          if($target.is(':hidden')){
            $trigger.addClass('active');
            $target.stop().slideDown(op.speed);
          }else{
            $trigger.removeClass('active');
            $target.stop().slideUp(op.speed);
          };
        };
        if($trigger.hasClass('active')){
          $target.show();
        };
        $trigger.off('click');
        $trigger.on('click',function(){
          toggleChange();
          return false;
        });
      };
    },
    // タブ切り替え
    tabSwitch:function(options){
      var defaults={
        trigger:'',
        target:'',
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $trigger=$t.find(op.trigger);
      var $target=$t.find(op.target);
      var $active=$t.find(op.trigger+'.active');
      var $blog=$t.closest('.sec-blog');
      var prm=urlPrmArr();
      var bool={
        loaded:true,
        switch:false
      };
      if(prm&&prm['category']){
        $active=$t.find(op.trigger+'[data-category="'+prm['category']+'"]');
        $active.addClass('active');
      };
      if($active.length==0){
        $active=$trigger.eq(0);
        $active.addClass('active');
      };
      var active_id=$active.attr('href');
      var $active_target=$t.find(active_id);
      var start=function(){
        if(bool.loaded){
          bool.loaded=false;
          bool.switch=true;
          $active_target.stop().animate({ opacity:1 },op.speed).addClass('active');
          if($blog.length){
            $target.not($active_target).css({ opacity:0 });
          }else{
            $target.not($active_target).css({ opacity:1 }).hide();
          };
        };
      };
      $trigger.each(function(){
        var $link=$(this);
        var id=$link.attr('href');
        var $id=$(id);
        if($id.length){
          $link.off('click');
          $link.on('click',function(){
            if(!$link.hasClass('active')&&bool.switch){
              bool.switch=false;
              $trigger.not($link).removeClass('active');
              $link.addClass('active');
              if($blog.length){
                $target.not($id).css({ opacity:0 }).removeClass('active');
                $id.stop().animate({ opacity:1 },op.speed,function(){
                  bool.switch=true;
                }).addClass('active');
              }else{
                $target.not($id).hide().removeClass('active');
                $id.stop().fadeIn(op.speed,function(){
                  bool.switch=true;
                }).addClass('active');
              };
            };
            return false;
          });
        };
      });

      $(document).ready(function(){
        start();
      });

      $(window).on('load',function(){
        start();
      });
    },
    // ヘッダー
    header:function(options){
      var defaults={
        prefix:'hd',
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $top=$t.find('.'+op.prefix+'-top');
      var $announcement=$('.announcement-bar');
      var $gnav=$('#gnav');
      var $gnav_btn=$t.find('a[href^="#gnav"]');
      var $gnav_close=$gnav.find('.gnav-close');
      var $nav_links=$gnav.find('.'+op.prefix+'-nav-links');
      var $nav_links_item=$nav_links.find('.'+op.prefix+'-nav-links--item');
      var $category=$('#'+op.prefix+'-category');
      var $category_links=$category.find('.'+op.prefix+'-category-links');
      var $category_links_item=$category_links.find('.'+op.prefix+'-category-links--item');
      var $category_target=$category.find('.'+op.prefix+'-category-target');
      var $category_sub=$category.find('.'+op.prefix+'-category-sub');
      var $category_sub_item=$category_sub.find('.'+op.prefix+'-category-sub--item');
      var $category_grandchild=$category.find('.'+op.prefix+'-category-grandchild');
      var $category_grandchild_item=$category_grandchild.find('.'+op.prefix+'-category-grandchild--item');
      var $category_btn=$t.find('a[href^="#'+op.prefix+'-category"]');
      var $category_close=$category.find('.'+op.prefix+'-close > a');
      var $search=$('#'+op.prefix+'-search');
      var $search_btn=$t.find('a[href^="#'+op.prefix+'-search"]');
      var $search_close=$search.find('.'+op.prefix+'-close > a');
      var $hd_overlay=$('<div class="'+op.prefix+'-overlay" />');
      var $btns=$t.find('.'+op.prefix+'-btns');
      var $btns_item=$btns.find('.'+op.prefix+'-btns-item');
      var frame={
        gnav:function(){
          var wh=$(window).height();
          var th=SETTING_GN.hh();
          if(!$('.shopify-section-header-sticky').length){
            var ah=$announcement.innerHeight();
            wh=wh-ah;
          };
          if(is_pc()) wh=wh-th;
          return wh;
        },
        category:function(){
          var wh=$(window).height();
          var th=SETTING_GN.hh();
          if(!$('.shopify-section-header-sticky').length){
            var ah=$announcement.innerHeight();
            wh=wh-ah;
          };
          wh=wh-th;
          return wh;
        }
      };
      var bool={
        gnav:false,
        category:false,
        search:false
      };
      var orientInterval;
      var gnav={
        open:function(){
          bool.gnav=true;
          if(bool.category) category.close();
          if(bool.search) search.close();
          $('body').addClass('body-gnav-open');
          $gnav_btn.addClass('active');
          $gnav.find('> .page-width').height(frame.gnav());
          if(is_sp()){
            $gnav.addClass('active');
          }else{
            $gnav.stop().slideDown(op.speed);
          };
          $hd_overlay.stop().fadeIn(op.speed);
          return false;
        },
        close:function(){
          bool.gnav=false;
          $('body').removeClass('body-gnav-open');
          $gnav_btn.removeClass('active');
          if(is_sp()){
            $gnav.removeClass('active');
          }else{
            $gnav.stop().slideUp(op.speed);
          };
          $hd_overlay.stop().fadeOut(op.speed);
          return false;
        }
      };
      var category={
        open:function(){
          bool.category=true;
          if(bool.gnav) gnav.close();
          if(bool.search) search.close();
          st=SETTING_GN.st();
          $('body').addClass('body-category-open');
          $category_btn.addClass('active');
          $category.find('> .page-width').css({ maxHeight:frame.category()+'px' });
          $category.stop().slideDown(op.speed);
          $hd_overlay.stop().fadeIn(op.speed);
          return false;
        },
        close:function(){
          bool.category=false;
          $('body').removeClass('body-category-open');
          $category_btn.removeClass('active');
          $category.stop().slideUp(op.speed);
          $hd_overlay.stop().fadeOut(op.speed);
          return false;
        }
      };
      var search={
        open:function(){
          bool.search=true;
          if(bool.gnav) gnav.close();
          if(bool.category) category.close();
          $('body').addClass('body-search-open');
          $search_btn.addClass('active');
          $search.stop().slideDown(op.speed);
          $hd_overlay.stop().fadeIn(op.speed);
          return false;
        },
        close:function(){
          bool.search=false;
          $('body').removeClass('body-search-open');
          $search_btn.removeClass('active');
          $search.stop().slideUp(op.speed);
          $hd_overlay.stop().fadeOut(op.speed);
          return false;
        }
      };

      $t.append($hd_overlay);
      
      $gnav_btn.off('click');
      $gnav_btn.on('click',function(){
        if(!bool.gnav){
          gnav.open();
        }else{
          gnav.close();
        };
        return false;
      });
      $gnav_close.off('click');
      $gnav_close.on('click',gnav.close);

      $nav_links_item.each(function(){
        var $item=$(this);
        var $link=$item.find('> a');
        if($link.hasClass('has-child')){
          var $sub=$item.find('.'+op.prefix+'-nav-sub');
          $link.off('click');
          $link.on('click',function(){
            if($sub.is(':hidden')){
              $(this).addClass('active');
              $sub.stop().slideDown(op.speed);
            }else{
              $(this).removeClass('active');
              $sub.stop().slideUp(op.speed);
            };
            return false;
          });
        };
      });

      if(is_pc()){
        if($category_links_item.find('.active').length==0){
          $category_links_item.eq(0).find('> a').addClass('active');
          $($category_links_item.eq(0).find('> a').attr('href')).show();
        };
      };

      $category_links_item.each(function(){
        var $item=$(this);
        var $link=$item.find('> a');
        var id=$link.attr('href');
        if($link.hasClass('has-child')){
          var $sub=$item.find('.'+op.prefix+'-category-sub');
          $link.off('click');
          $link.on('click',function(){
            if(is_sp()){
              if($sub.is(':hidden')){
                $(this).addClass('active');
                $sub.stop().slideDown(op.speed);
              }else{
                $(this).removeClass('active');
                $sub.stop().slideUp(op.speed);
              };
            }else{
              $category_links_item.find('.active').removeClass('active');
              $category_target.not($(id)).hide();
              if($(id).is(':hidden')){
                $(this).addClass('active');
                $(id).stop().fadeIn(op.speed);
              }else{
                $(this).removeClass('active');
                $(id).stop().fadeOut(op.speed);
              };
            };
            return false;
          });
        };
      });

      $category_sub_item.each(function(){
        var $item=$(this);
        var $link=$item.find('> a');
        if($link.hasClass('has-child')){
          var $child=$item.find('> .'+op.prefix+'-category-sub__child');
          $link.off('click');
          $link.on('click',function(){
            if($child.is(':hidden')){
              $(this).addClass('active');
              $child.stop().slideDown(op.speed);
            }else{
              $(this).removeClass('active');
              $child.stop().slideUp(op.speed);
            };
            return false;
          });
        };
      });

      $category_grandchild_item.each(function(){
        var $item=$(this);
        var $link=$item.find('> a');
        if($link.hasClass('has-child')){
          var $grandchild=$item.find('.'+op.prefix+'-category-grandchild');
          $link.off('click');
          $link.on('click',function(){
            if($grandchild.is(':hidden')){
              $(this).addClass('active');
              $grandchild.stop().slideDown(op.speed);
            }else{
              $(this).removeClass('active');
              $grandchild.stop().slideUp(op.speed);
            };
            return false;
          });
        };
      });

      $category_btn.off('click');
      $category_btn.on('click',function(){
        if(!bool.category){
          category.open();
        }else{
          category.close();
        };
        return false;
      });
      $category_close.off('click');
      $category_close.on('click',category.close);

      $search_btn.off('click');
      $search_btn.on('click',function(){
        if(!bool.search){
          search.open();
        }else{
          search.close();
        };
        return false;
      });
      $search_close.off('click');
      $search_close.on('click',search.close);

      $hd_overlay.off('click');
      $hd_overlay.on('click',function(){
        gnav.close();
        category.close();
        search.close();
      });

      $btns_item.each(function(){
        var $item=$(this);
        var $link=$item.find('> a');
        if($link.hasClass('has-child')){
          var $sub=$item.find('.'+op.prefix+'-btns-sub');
          $link.off('click');
          $link.on('click',function(){
            if(is_pc()){
              if($sub.is(':hidden')){
                $(this).addClass('active');
                $sub.stop().slideDown(op.speed);
              }else{
                $(this).removeClass('active');
                $sub.stop().slideUp(op.speed);
              };
              return false;
            };
          });
        };
      });

      $(window).on({
        'orientationchange':function(){
          if($gnav_btn.hasClass('active')){
            clearTimeout(orientInterval);
            orientInterval=setTimeout(function(){
              $gnav.find('> .page-width').height(frame.gnav());
              $category.find('> .page-width').css({ maxHeight:frame.category()+'px' });
            },200);
          };
        },
        'resize':function(){
          if(is_pc()){
            $gnav.find('> .page-width').height(frame.gnav());
            $category.find('> .page-width').css({ maxHeight:frame.category()+'px' });
          };
        }
      });

    },
    // バリーションサムネイルのスライド
    variantSlide:function(options){
      var defaults={
        prefix:'card-variants',
        base:{
          sp:150,
          pc:392
        },
        w:{
          sp:37.5,
          pc:64
        },
        space:{
          sp:0,
          pc:0
        },
        scroll:true,
        speed:0.4
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $frame=$t.find('.'+op.prefix+'-frame');
      var $move=$t.find('.'+op.prefix+'-move');
      var $item=$move.find('.'+op.prefix+'-item');
      var $card=$t.closest('.card');
      var $media=$card.find('.media');
      var $media_img=$media.find('img');
      var direct;
      var $direct={
        prev:$('<a class="'+op.prefix+'-direct '+op.prefix+'-direct--prev" href="#">PREV</a>'),
        next:$('<a class="'+op.prefix+'-direct '+op.prefix+'-direct--next" href="#">NEXT</a>')
      };
      var len=$item.length;
      var frame=function(){ var v=$frame.innerWidth(); return Math.round(v); };
      var calc=function(n){ var v=(is_sp())?frame()*(n/op.base.sp):frame()*(n/op.base.pc); return Math.round(v); };
      var w=function(){ var v=(is_sp())?calc(op.w.sp):calc(op.w.pc); return v; };
      var space=function(){ var v=(is_sp())?calc(op.space.sp):calc(op.space.pc); return v; };
      var w_slide=function(){ var v=w()+space(); return v; };
      var group=function(){ var v=frame()/w_slide(); return Math.floor(v); };
      var move=function(){ var v=(len>group()&&group()>0)?true:false; return v; };
      var move_w=function(){ var v=w_slide()*len; return v; };
      var current=function(){ var v=$frame.scrollLeft(); return Math.round(v); };
      var first=true;
      var touch={
        X:0,
        move:0,
        pos:0,
        current:0,
        bool:false,
        mouse:false,
        click:true
      };
      var initialize=function(){
        $move.width(move_w()).css({ transition:'unset',transform:'translate3d('+current()+'px,0,0)',margin:'0 0 0 -'+space()+'px' });
        $item.show().width(w()).css({ marginLeft:space()+'px' });
      };
      var directControl=function(){
        if(current()==0){
          $direct.prev.hide();
          $direct.next.show();
        }else if(current()>=(move_w()-frame())){
          $direct.prev.show();
          $direct.next.hide();
        }else{
          $direct.prev.show();
          $direct.next.show();
        };
      };
      var slideDirectInterval;
      var scrollInterval;
      var slideEvent={
        move:function(){
          clearInterval(slideDirectInterval);
          var scroll_move=current();
          var scrollMove=function(){
            clearInterval(scrollInterval);
            scrollInterval=setTimeout(function(){
              $frame.scrollLeft(scroll_move);
              scroll_move=(direct=='prev')?scroll_move-1:scroll_move+1;
              scrollMove();
            },op.speed);
          };
          scrollMove();
          slideEvent.detect();
        },
        stop:function(){
          clearInterval(slideDirectInterval);
          clearInterval(scrollInterval);
        },
        detect:function(){
          slideDirectInterval=setInterval(function(){
            directControl();
          },op.speed);
        }
      };
      var start=function(){
        initialize();
        if(first){
          first=false;
          if(move()){
            $t.append($direct.prev,$direct.next);
            directControl();
            setTimeout(function(){
              $t.animate({ opacity:1 },400);
              initialize();
            },200);
            $direct.prev.off('click mouseenter mouseleave');
            $direct.prev.on({
              'click':function(){ return false; },
              'mouseenter':function(){
                if(touch.click){
                  direct='prev';
                  slideEvent.move();
                };
              },
              'mouseleave':function(){
                slideEvent.stop();
              }
            });
            $direct.next.off('click mouseenter mouseleave');
            $direct.next.on({
              'click':function(){ return false; },
              'mouseenter':function(){
                if(touch.click){
                  direct='next';
                  slideEvent.move();
                };
              },
              'mouseleave':function(){
                slideEvent.stop();
              }
            });
            $frame.on({
              'scroll':function(){
                directControl();
              }
            });
            $move.off('mouseenter mousenmove mouseleave mouseup');
            $move.on({
              'mousedown':function(event){
                if(!is_touch()){
                  touch.bool=true;
                  touch.mouse=true;
                  $move.addClass('grabbed');
                  touch.X=event.clientX;
                  touch.current=current();
                };
              },
              'mousemove':function(event){
                if(!is_touch()){
                  if(touch.mouse){
                    touch.click=false;
                    if(event.cancelable) event.preventDefault();
                    touch.pos=Math.floor(event.clientX);
                    touch.move=touch.X-touch.pos+touch.current;
                    $frame.scrollLeft(touch.move);
                  };
                };
              },
              'mouseleave mouseup':function(event){
                if(!is_touch()){
                  if(touch.mouse){
                    touch.mouse=false;
                    bool=false;
                    $move.removeClass('grabbed');
                    setTimeout(function(){
                      touch.click=true;
                    },100);
                  };
                };
              }
            });
          }else{
            setTimeout(function(){
              $t.animate({ opacity:1 },400);
              initialize();
            },200);
          };
          $item.each(function(){
            var $this_item=$(this);
            var src=$this_item.find('img').attr('src');
            $this_item.off('click');
            $this_item.on('click',function(){
              if(touch.click){
                $media_img.attr('src',src);
              };
            });
          });
          if(op.afterLoad) op.afterLoad($t);
        };
      };
      
      if($item.eq(len-1).find('img').length){
        $item.eq(len-1).find('img').one('load',function(){
          start();
        }).each(function(){
          if(this.complete) start();
        });
      }else{
        $(document).ready(function(){
          start();
        });
      };

      $(window).on({
        'resize':function(){
          initialize();
          if(is_pc()&&op.scroll){
            $frame.scrollLeft(0);
          };
        }
      });

    },
    // ajaxで次の記事を取得
    ajaxMorePosts:function(options){
      var defaults={
        afterLoad:new Function
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $trigger=$t.find('> a');
      var post=$t.data('post');
      var pagination=$t.data('pagination');
      var $post=$(post);
      var $pagination=$(pagination);
      var prev=$pagination.attr('href');
      var len=$post.length;
      var bool=true;
      var morePosts=function(){
        $.ajax({
          url:prev,
          dataType:'html'
        }).done(function(data){
          var $data=$(data);
          var $data_post=$data.find(post);
          var $data_pagination=$data.find(pagination);
          $post.eq(len-1).after($data_post);
          $post=$(post);
          len=$post.length;
          if($data_pagination.length){
            prev=$data_pagination.attr('href');
          }else{
            $t.hide();
          };
          op.afterLoad($data_post);
          bool=true;
        });
      };
      $trigger.off('click');
      $trigger.on('click',function(){
        if(bool){
          bool=false;
          morePosts();
        };
        return false;
      });
    },
    // アイテム切り替え
    switchOrderItem:function(options){
      var defaults={
        prefix:{
          parent:'',
          item:''
        },
        orderArr:[],
        speed:1000,
        interval:3000
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $base=$t.find('.'+op.prefix.parent+'__base');
      var $base_item=$base.find('.'+op.prefix.item+'-item');
      var $targets=$t.find('.'+op.prefix.parent+'__targets');
      var $targets_item=$targets.find('.'+op.prefix.item+'-item');
      var index=0;
      var targetsIndexArr=[];
      var orderArr=[];
      for(var i in op.orderArr){
        var order=op.orderArr[i]['order'];
        orderArr.push(order);
      };
      var len={
        item:$targets_item.length,
        order:Math.max.apply(null,orderArr)
      };
      var bool={
        start:true
      };
      var dissolove=function(){
        index=(index==len.order)?1:index+1;
        targetsIndexArr=[];
        var newOrderArr=op.orderArr.filter(function(o){
          if(o.order==index) return true;
        });
        $base_item.stop().animate({ opacity:0 },op.speed);
        $targets_item.stop().animate({ opacity:0 },op.speed);
        for(var i in newOrderArr){
          var item=newOrderArr[i];
          var $item=$('#'+item.id);
          $item.stop().animate({ opacity:1 },op.speed);
          targetsIndexArr.push($targets_item.index($item));
        };
        for(var i=0;i<len.item;i++){
          if(targetsIndexArr.indexOf(i)==-1){
            var $item=$base_item.eq(i);
            $item.stop().animate({ opacity:1 },op.speed);
          };
        };
        setTimeout(function(){
          dissoloveAuto();
        },op.speed);
      };
      var dissoloveAuto;
      var dissoloveInterval;
      dissoloveAuto=function(){
        clearTimeout(dissoloveInterval);
        dissoloveInterval=setTimeout(function(){
          dissolove();
        },op.interval);
      };
      var start=function(){
        if(bool.start){
          bool.start=false;
          dissolove();
        };
      };

      if($targets_item.eq(len.item-1).find('img').length){
        $targets_item.eq(len.item-1).find('img').one('load',function(){
          start();
        }).each(function(){
          if(this.complete) start();
        });
      }else{
        $(document).ready(function(){
          start();
        });
      };

    },
    // フォームバリデート
    formValidate:function(options){
      var defaults={
        prefix:'form-validate'
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $required=$t.find('[required]');
      var $kana=$t.find('.'+op.prefix+'-kana');
      var $kana_message=$kana.find('.form-message');
      var $email=$t.find('.'+op.prefix+'-email');
      var $email_input=$email.find('input');
      var $confemail=$t.find('.'+op.prefix+'-confemail');
      var $confemail_input=$confemail.find('input');
      var $confemail_message=$confemail.find('.form-message');
      var $submit=$t.find('.'+op.prefix+'-submit');
      var len=$required.length;
      var moveToMessage=function($target){
        $('html:not(:animated),body:not(:animated)').animate({ scrollTop:($target.offset().top-SETTING_GN.hh())+'px' },100);
      };

      $t.attr('novalidate',true);

      $t.off('submit');
      $t.on('submit',function(){
        for(var i=0;i<len;i++){
          var $this_required=$required.eq(i);
          var $this_target=$this_required.closest('.form-box,.form-parts-agree,.form-table-tr');
          var $this_message=$this_target.find('.form-message');
          if($this_required.val()){
            $this_message.hide();
            if($this_target.hasClass(op.prefix+'-kana')){
              var v={
                kana:$this_required.val()
              };
              if(!v.kana.match(/^[ァ-ヶー　]+$/)){
                moveToMessage($kana);
                $kana_message.show();
                return false;
              };
            };
            if($this_target.hasClass(op.prefix+'-confemail')){
              var v={
                email:$email_input.val(),
                confemail:$confemail_input.val()
              };
              if(v.email!=v.confemail){
                moveToMessage($confemail);
                $confemail_message.show();
                return false;
              };
            };
          }else{
            moveToMessage($this_target);
            return false;
          };
          if($this_target.hasClass('form-parts-agree')){
            if(!$this_required.is(':checked')){
              moveToMessage($this_target);
              return false;
            };
          };
        };
      });

      $submit.off('click');
      $submit.on('click',function(){
        $t.submit();
        return false;
      });
    },
    // お届け先の管理
    accountAddresses:function(options){
      var defaults={
        prefix:'page-addresses',
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $edit=$t.find('.'+op.prefix+'-edit');
      var $btn_edit=$t.find('.btn-edit');
      var $btn_add=$t.find('.btn-add');
      var $btn_cancel=$t.find('.btn-cancel');
      var $target={
        default:$t.find('#Default'),
        editAddress:$t.find('#EditAddress'),
        addAddress:$t.find('#AddAddress')
      };
      var buttonDefaultAction=function(type){
        switch(type){
        case 'edit' :
          $target.default.hide();
          $target.editAddress.show();
          $target.addAddress.hide();
          break;
        case 'add' :
          $target.default.hide();
          $target.editAddress.hide();
          $target.addAddress.show();
          break;
        case 'cancel' :
          $target.default.show();
          $target.editAddress.hide();
          $target.addAddress.hide();
          break;
        };
        var top=$t.offset().top;
        $('html:not(:animated),body:not(:animated)').animate({ scrollTop:top+'px' },op.speed);
      };
      $btn_edit.each(function(){
        var $btn=$(this);
        $btn.off('click');
        $btn.on('click',function(){
          var id=$(this).attr('href');
          var $id=$(id);
          buttonDefaultAction('edit');
          $edit.not($id).hide();
          $id.show();
          return false;
        });
      });

      $btn_add.off('click');
      $btn_add.on('click',function(){
        buttonDefaultAction('add');
        return false;
      });

      $btn_cancel.each(function(){
        var $btn=$(this);
        $btn.on('click',function(){
          buttonDefaultAction('cancel');
        });
      });
      
    },
    // スライド
    styleSlide:function(options){
      var defaults={
        prefix:'',
        base:{
          sp:750,
          pc:1140
        },
        w:{
          sp:100,
          pc:200
        },
        space:{
          sp:0,
          pc:0
        },
        indicator:false,
        direct:false,
        bullets:false,
        loop:false,
        scroll:false,
        layout:false,
        speed:0.4,
        interval:0,
        afterLoad:new Function
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $frame=$t.find('.'+op.prefix+'-frame');
      var $move=$t.find('.'+op.prefix+'-move');
      var $item=$move.find('.'+op.prefix+'-item');
      var $indicator=$('<div class="'+op.prefix+'-indicator" />');
      var $indicator_content=$('<div class="'+op.prefix+'-indicator--content" />');
      var $direct={
        prev:$('<a class="'+op.prefix+'-direct '+op.prefix+'-direct--prev" href="#">PREV</a>'),
        next:$('<a class="'+op.prefix+'-direct '+op.prefix+'-direct--next" href="#">NEXT</a>')
      };
      var $bullets=$('<div class="'+op.prefix+'-bullets page-width" />');
      var $bullets_content=$('<div class="'+op.prefix+'-bullets--content" />');
      var $tab=$t.closest('.tab-1');
      var len=$item.length;
      var len2=len;
      var index=(op.loop)?len:0;
      var frame=function(){ var v=$frame.innerWidth(); return Math.round(v); };
      var calc=function(n){ var v=(is_sp())?frame()*(n/op.base.sp):frame()*(n/op.base.pc); return Math.round(v); };
      var w=function(){ var v=(is_sp())?calc(op.w.sp):calc(op.w.pc); return v; };
      var space=function(){ var v=(is_sp())?calc(op.space.sp):calc(op.space.pc); return v; };
      var w_slide=function(){ var v=w()+space(); return v; };
      var group=function(){ var v=frame()/w_slide(); return Math.round(v); };
      var limited=function(){ var v=len-group(); return Math.round(v); };
      var indicator_scale_w=function(){ var v=$indicator_content.width()/(limited()+1); return v; };
      var bool=true;
      var first=true;
      var pageWidth=$t.closest('.page-width').length;
      var move=function(){ var v=(len>group()&&group()>0)?true:false; return v; };
      var touch={
        X:0,
        now:0,
        move:0,
        pos:0,
        bool:false,
        left:function(){ v=new WebKitCSSMatrix($move.css('transform')); return Math.floor(v.e); }
      };
      var initialize=function(){
        clearTimeout(slideInterval);
        if(w()>0){
          var move_w=(op.scroll)?(w_slide()*len)+space():w_slide()*len2;
          $move.width(move_w).css({ transform:'translate3d(-'+(w_slide()*index)+'px,0,0)',margin:'0 0 0 -'+space()+'px' });
          $item.show().width(w()).css({ marginLeft:space()+'px' });
          switch(op.layout){
          case 1 :
            if(is_sp()){
              var marginLeft=Math.abs(space()-24);
            }else{
              if(SETTING_GN.ww()>1860){
                var marginLeft=Math.abs(space()-((SETTING_GN.ww()-1760)/2));
              }else{
                var marginLeft=Math.abs(space()-50);
              };
            };
            $move.css({ marginLeft:marginLeft+'px' });
            break;
          };
          if(pageWidth){
            if(is_sp()){
              var marginLeft=Math.abs(space()-24);
            }else{
              var marginLeft='-'+space();
            };
            $move.css({ marginLeft:marginLeft+'px' });
          };
          if(op.indicator) $indicator.show();
          if(op.direct) directControl();
          if(op.bullets) $bullets.show();
        }else{
          $move.width('').css({ transition:'',transform:'',margin:'' });
          $item.hide().width('').css({ marginLeft:'' });
          $move.find('.'+op.prefix+'-item.origin').show();
          if(op.indicator) $indicator.hide();
          if(op.direct){
            $direct.prev.hide();
            $direct.next.hide();
          };
          if(op.bullets) $bullets.hide();
        };
        if(op.indicator){
          var indicator_scale_index=(op.loop)?index-len:index;
          $indicator.find('span').width(indicator_scale_w()).css({ left:(indicator_scale_w()*indicator_scale_index) });
        };
        if(op.direct){
          var h={
            max:0,
            arr:[]
          };
          for(var i=0;i<len;i++){
            h.arr.push($item.find('img').height());
          };
          h.max=Math.max.apply(null,h.arr);
          if(h.max>0){
            $direct.prev.css({ top:(h.max/2)+'px' });
            $direct.next.css({ top:(h.max/2)+'px' });
          };
        };
        if(op.scroll){
          $item.hide();
          $move.find('.'+op.prefix+'-item.origin').show();
        };
        slideAuto();
      };
      var indicatorControl=function(){
        var indicator_scale_index=(op.loop)?index-len:index;
        $indicator.find('span').css({ left:(indicator_scale_w()*indicator_scale_index) });
      };
      var directControl=function(){
        if(op.loop){
          $direct.prev.show();
          $direct.next.show();
        }else{
          if(index==0){
            $direct.prev.hide();
            $direct.next.show();
          }else if(index>=limited()){
            $direct.prev.show();
            $direct.next.hide();
          }else{
            $direct.prev.show();
            $direct.next.show();
          };
        };
      };
      var bulletsControl=function(){
        var bullets_index=(op.loop)?index-len:index;
        $bullets.find('a.active').removeClass('active');
        $bullets.find('a').eq(bullets_index).addClass('active');
      };
      var slideEvent=function(){
        var move_slide=(w_slide()*index);
        /*
        if(!op.loop&&index==limited()){
          move_slide=(w_slide()*(limited()-1));
          move_slide=(move_slide+(($move.width()-frame())-move_slide))-(space());
        };
        */
        $move.css({ transitionTimingFunction:'ease-out',transition:op.speed+'s',transform:'translate3d(-'+move_slide+'px,0,0)' });
        setTimeout(function(){
          if(op.loop){
            if(index==len-1){
              index=len*2-1;
            }else if(index==len*2){
              index=len;
            };
            $move.css({ transitionTimingFunction:'none',transition:'none',transform:'translate3d(-'+(w_slide()*index)+'px,0,0)' });
          }else{
            if(op.direct) directControl();
            if(op.indicator) indicatorControl();
            if(op.bullets) bulletsControl();
          };
          $item.removeClass('active');
          $item.eq(index).addClass('active');
          if(op.indicator) indicatorControl();
          if(op.bullets) bulletsControl();
          bool=true;
          slideAuto();
        },op.speed*1000);
      };
      var slideAuto;
      var slideInterval;
      slideAuto=function(){
        if(op.interval){
          slideInterval=setTimeout(function(){
            if(bool){
              bool=false;
              index=index+1;
              clearTimeout(slideInterval);
              slideEvent();
            };
          },op.interval);
        };
      };
      var resetSlide=function(){
        clearTimeout(slideInterval);
        $move.css({ transitionTimingFunction:'none',transition:'none' });
        if(move()){
          setTimeout(function(){ slideAuto(); },op.interval);
        };
        initialize();
      };
      var start=function(){
        initialize();
        if(first){
          first=false;
          if(move()){
            if(op.loop){
              for(var i=0;i<len;i++){
                $move.append($item.eq(i).clone(true));
                $move.prepend($item.eq((len-1)-i).clone(true));
              };
              $item=$move.find('.'+op.prefix+'-item');
              len2=$item.length;
            };
            $item.eq(index).addClass('active');
            if(op.indicator){
              switch(op.layout){
                case 1 :
                  $indicator.addClass('page-width');
                  break;
              };
              $indicator_content.append('<span />');
              $indicator.append($indicator_content);
              $t.append($indicator);
              indicatorControl();
            };
            if(op.direct){
              $t.append($direct.prev,$direct.next);
              directControl();
            };
            if(op.bullets){
              for(var i=0;i<len;i++){
                $bullets_content.append('<a href="#">'+(i+1)+'</a>');
              };
              $bullets.append($bullets_content);
              $t.append($bullets);
              bulletsControl();
            };
            if(op.scroll){
              $t.addClass(op.prefix+'-scroll');
            };
            setTimeout(function(){
              $t.animate({ opacity:1 },400);
              resetSlide();
            },200);
            $direct.prev.off('click');
            $direct.prev.on('click',function(){
              if(bool){
                bool=false;
                index=index-1;
                clearTimeout(slideInterval);
                slideEvent();
              };
              return false;
            });
            $direct.next.off('click');
            $direct.next.on('click',function(){
              if(bool){
                bool=false;
                index=index+1;
                clearTimeout(slideInterval);
                slideEvent();
              };
              return false;
            });
            $bullets.find('a').each(function(){
              $(this).off('click');
              $(this).on('click',function(){
                if(bool){
                  bool=false;
                  index=$bullets.find('a').index($(this));
                  index=(op.loop)?index+len:index;
                  clearTimeout(slideInterval);
                  slideEvent();
                };
                return false;
              });
            });
            if(!op.scroll){
              $move.on({
                'touchstart':function(event){
                  touch.bool=true;
                  $(this).css({ transitionTimingFunction:'none',transition:'none' });
                  touch.X=event.touches[0].pageX;
                  touch.Y=event.touches[0].pageY;
                  touch.move=touch.X-touch.left();
                  touch.now=Math.floor(new WebKitCSSMatrix($move.css('transform')).e);
                },
                'touchmove':function(event){
                  if(Math.abs(touch.X-event.touches[0].pageX)>5&&touch.bool){
                    if(event.cancelable) event.preventDefault();
                    touch.pos=Math.floor(event.touches[0].pageX);
                    $(this).css({ transform:'translate3d('+(touch.pos-touch.move)+'px,0,0)' });
                  }else{
                    touch.bool=false;
                  };
                },
                'touchend':function(event){
                  if(bool&&touch.bool){
                    bool=false;
                    if(op.loop){
                      if((touch.pos-touch.move)>=0){
                        index=0;
                      }else if(touch.now>touch.left()){
                        index=index+1;
                      }else if(touch.now<touch.left()){
                        index=index-1;
                      };
                    }else{
                      if((touch.pos-touch.move)>=0){
                        index=0;
                      }else if(touch.now>touch.left()){
                        index=(index==limited())?limited():index+1;
                      }else if(touch.now<touch.left()){
                        index=(index==0)?0:index-1;
                      };
                    };
                    clearTimeout(slideInterval);
                    slideEvent();
                  };
                }
              });
            };
          }else{
            index=0;
            $item.eq(index).addClass('active');
            setTimeout(function(){
              $t.animate({ opacity:1 },400);
              resetSlide();
            },200);
          };
          for(var i=0;i<len;i++){
            $item.eq(i).addClass('origin');
          };
          if($tab.length){
            $tab.find('.tab-1-trigger a').on('click',function(){
              initialize();
            });
          };
          if(op.afterLoad) op.afterLoad($t);
        };
      };

      start();

      if($item.eq(len-1).find('img').length){
        $item.eq(len-1).find('img').one('load',function(){
          start();
        }).each(function(){
          if(this.complete) start();
        });
      }else{
        $(document).ready(function(){
          start();
        });
      };

      $(window).on({
        'resize':function(){
          $move.css({ transitionTimingFunction:'none',transition:'none' });
          initialize();
        }
      });
    },
    // 自動スライド
    styleAutoSlide:function(options){
      var defaults={
        prefix:'slide-auto',
        base:{
          sp:750,
          pc:1140
        },
        w:{
          sp:100,
          pc:200
        },
        space:{
          sp:0,
          pc:0
        },
        type:'',
        speed:8
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $frame=$t.find('.'+op.prefix+'-frame');
      var $move=$t.find('.'+op.prefix+'-move');
      var $item=$move.find('.'+op.prefix+'-item');
      var len=$item.length;
      var len2=len;
      var index=len;
      var frame=function(){ var v=$frame.innerWidth(); return Math.round(v); };
      var calc=function(n){
        if(op.type==1&&is_pc()){
          return n;
        }else{
          var v=(is_sp())?frame()*(n/op.base.sp):frame()*(n/op.base.pc);
          return Math.round(v);
        };
      };
      var w=function(){ var v=(is_sp())?calc(op.w.sp):calc(op.w.pc); return v; };
      var space=function(){ var v=(is_sp())?calc(op.space.sp):calc(op.space.pc); return v; };
      var w_slide=function(){ var v=w()+space(); return v; };
      var w_total=function(){ var v=w_slide()*len; return v; };
      var first=true;
      var initialize=function(){
        var move_w=w_slide()*len2;
        $move.width(move_w).css({ marginLeft:'-'+space()+'px' });
        $item.show().width(w()).css({ marginLeft:space()+'px' });
      };
      var slideEvent=function(){
        var duration=op.speed*len;
        $move.css({ transition:'linear '+duration+'s',transform:'translate3d(-'+w_total()+'px,0,0)' });
        setTimeout(function(){
          $move.css({ transition:'unset',transform:'unset' });
          setTimeout(function(){
            slideEvent();
          },5);
        },duration*1000);
      };
      var start=function(){
        if(first){
          first=false;
          for(var i=0;i<len;i++){
            $move.append($item.eq(i).clone(true));
            $move.prepend($item.eq((len-1)-i).clone(true));
          };
          $item=$move.find('.'+op.prefix+'-item');
          len2=$item.length;
          $item.eq(index).addClass('active');
          setTimeout(function(){
            $t.animate({ opacity:1 },400);
            slideEvent();
            initialize();
          },200);
        };
      };

      if($item.eq(len-1).find('img').length){
        $item.eq(len-1).find('img').one('load',function(){
          start();
        }).each(function(){
          if(this.complete) start();
        });
      }else{
        $(document).ready(function(){
          start();
        });
      };

      $(window).on({
        'resize':function(){
          initialize();
        }
      });
    }
  });

  $('a[href^="#"]').not($('a.disable-hash')).pageScroll();
  if($('#header').length) $('#header').header();

  if($('.click-logout').length) $('body').logoutLocation();

  if($('.tab-1').length){
    $('.tab-1').each(function(){
      $(this).tabSwitch({
        trigger:'.tab-1-trigger a',
        target:'.tab-1-target'
      });
    });
  };

  if($('.tab-2').length){
    $('.tab-2').each(function(){
      $(this).tabSwitch({
        trigger:'.tab-2-trigger a',
        target:'.tab-2-target'
      });
    });
  };

  if($('.tab-3').length){
    $('.tab-3').each(function(){
      $(this).tabSwitch({
        trigger:'.tab-3-trigger a',
        target:'.tab-3-target'
      });
    });
  };

  if($('.sec-brand-switch').length){
    $('.sec-brand-switch').switchOrderItem({
      prefix:{
        parent:'sec-brand-switch',
        item:'brand-1'
      },
      orderArr:brandOrderArr
    });
  };

  if($('.page-cart-guid__lists').length){
    $('.page-cart-guid__lists dl').each(function(){
      $(this).toggleBox({
        trigger:'dt',
        target:'dd'
      });
    });
  };

  if($('.card-variants').length){
    $('.card-variants').each(function(){
      $(this).variantSlide();
    });
  };

  if($('.more-1-post').length){
    $('.more-1-post').ajaxMorePosts({
      afterLoad:function($post){
        if($post.find('.card-variants').length){
          $post.find('.card-variants').each(function(){
            $(this).variantSlide();
          });
        };
      }
    });
  };

  if($('#create_customer').length){
    $('#create_customer').formValidate();
  };

  if($('.page-addresses').length){
    $('.page-addresses').accountAddresses();
    if($('.page-addresses-form').length){
      $('.page-addresses-form').each(function(){
        $(this).find(' > form').formValidate();
      });
    };
  };

  var loadSlide=function(){
    if($('.slide-1').length){
      $('.slide-1').each(function(){
        if(!$(this).hasClass('slide-started')){
          var base={
            sp:$(this).data('slide-sp-base'),
            pc:$(this).data('slide-pc-base')
          };
          var w={
            sp:$(this).data('slide-sp-w'),
            pc:$(this).data('slide-pc-w')
          };
          var space={
            sp:$(this).data('slide-sp-space'),
            pc:$(this).data('slide-pc-space')
          };
          var indicator=$(this).data('slide-indicator');
          var direct=$(this).data('slide-direct');
          var bullets=$(this).data('slide-bullets');
          var loop=$(this).data('slide-loop');
          var scroll=$(this).data('slide-scroll');
          var layout=$(this).data('slide-layout');
          $(this).addClass('slide-started');
          $(this).styleSlide({
            prefix:'slide-1',
            base:base,
            w:w,
            space:space,
            indicator:indicator,
            direct:direct,
            bullets:bullets,
            loop:loop,
            scroll:scroll,
            layout:layout
          });
        };
      });
    };
    if($('.slide-auto').length){
      $('.slide-auto').each(function(){
        if(!$(this).hasClass('slide-started')){
          var base={
            sp:$(this).data('slide-sp-base'),
            pc:$(this).data('slide-pc-base')
          };
          var w={
            sp:$(this).data('slide-sp-w'),
            pc:$(this).data('slide-pc-w')
          };
          var space={
            sp:$(this).data('slide-sp-space'),
            pc:$(this).data('slide-pc-space')
          };
          var type=$(this).data('slide-type');
          $(this).addClass('slide-started');
          $(this).styleAutoSlide({
            prefix:'slide-auto',
            base:base,
            w:w,
            space:space,
            type:type
          });
        };
      });
    };
  };
  loadSlide();

  $(window).on({
    'load resize':function(){
      loadSlide();
    }
  });

   $('body').winSizeSet({
    set:function($t){
      if(is_sp()){
        $t.addClass('device-sp').removeClass('device-pc');
      }else{
        $t.removeClass('device-sp').addClass('device-pc');
      };
    }
  });

  if(is_touch()){
    $('body').addClass('device-touch');
  }else{
    $('body').addClass('device-click');
  };
 
  if($('.guide-content').length){

    $('.guide-accordion__question--02').click(function() {
      $(this).toggleClass('active');
    });

    $('.guide-accordion__answer--02').hide();
    $('.guide-accordion__answer--02.open').show();
    $('.guide-accordion__question--02').click(function()
    {
        $(this).next().slideToggle();
    });
  };

});